import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerIntegralExchangeRewardListDataApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeReward/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppConsumerIntegralExchangeRewardExportDataApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeReward/exportData",
    method: "post",
    data
  });
}
// 导出图片
export function loadAppConsumerIntegralExchangeRewardExportPicZipApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeReward/exportPicZip",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppConsumerIntegralExchangeRewardApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeReward/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppConsumerIntegralExchangeRewardApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeReward/init",
    method: "post",
    data
  });
}

// 根据条件获取条数
export function findAppConsumerIntegralExchangeRewardCountByConditionApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeReward/findCountByCondition",
    method: "post",
    data
  });
}

// 根据条件获取数据
export function listAppConsumerIntegralExchangeRewardListDataApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeReward/listSelectData",
    method: "post",
    data
  });
}